import classNames from 'classnames';
import { FC } from 'react';

import { IcProfile16Icon } from '@gem/icons';
import { IconView, IconViewSizes, Loader } from '@gem/ui-kit';

import { IQuotedTextTitle } from '../QuotedText.presenter';
import styles from './QuotedTextTitle.styles.m.css';

interface IQuotedTextTitleProps {
  title: IQuotedTextTitle | null;
  className?: string;
  isLoading: boolean;
}

export const QuotedTextTitle: FC<IQuotedTextTitleProps> = ({ title, isLoading, className }) => {
  if (!title) {
    return null;
  }

  const containerClassName = classNames(styles.container, className);

  return (
    <p className={containerClassName}>
      <span className={styles.text}>{title.text}</span>
      {title.senderName && (
        <span className={styles.sender}>
          <IconView
            className={styles.profileIcon}
            Icon={IcProfile16Icon}
            size={IconViewSizes.Small}
          />
          <span className={styles.senderName}>{title.senderName}</span>
        </span>
      )}
      {isLoading && (
        <span>
          <Loader color="current" />
        </span>
      )}
    </p>
  );
};
